"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * ServiceNow AI Toolkit
 * ServiceNow AI Toolkit API
 *
 * The version of the OpenAPI document:
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleApi = exports.RoleApiFactory = exports.RoleApiFp = exports.RoleApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * RoleApi - axios parameter creator
 * @export
 */
const RoleApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get policies in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountRoleGet: (accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (accountId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountRoleGet', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/role`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create role in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RolePost} [rolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountRolePost: (accountId_1, human_1, rolePost_1, ...args_1) => __awaiter(this, [accountId_1, human_1, rolePost_1, ...args_1], void 0, function* (accountId, human, rolePost, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountRolePost', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/role`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rolePost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get roles in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterRoleGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/cluster/role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get roles in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationRoleGet: (organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (organizationId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationRoleGet', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}/role`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create role in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RolePost} [rolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationRolePost: (organizationId_1, human_1, rolePost_1, ...args_1) => __awaiter(this, [organizationId_1, human_1, rolePost_1, ...args_1], void 0, function* (organizationId, human, rolePost, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationRolePost', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}/role`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rolePost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get roles in the resource
         * @param {string} resourceId The ID or fullname of the resource
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResourceRoleGet: (resourceId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [resourceId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (resourceId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'resourceId' is not null or undefined
            (0, common_1.assertParamExists)('v1ResourceRoleGet', 'resourceId', resourceId);
            const localVarPath = `/v1/resource/{resource_id}/role`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create role in the resource
         * @param {string} resourceId The ID or fullname of the resource
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RolePost} [rolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResourceRolePost: (resourceId_1, human_1, rolePost_1, ...args_1) => __awaiter(this, [resourceId_1, human_1, rolePost_1, ...args_1], void 0, function* (resourceId, human, rolePost, options = {}) {
            // verify required parameter 'resourceId' is not null or undefined
            (0, common_1.assertParamExists)('v1ResourceRolePost', 'resourceId', resourceId);
            const localVarPath = `/v1/resource/{resource_id}/role`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rolePost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check permission (action & resource) for a given role
         * @param {string} action Expression (supporting wildcards) denoting the action(s) performed on the resource(s)
         * @param {string} resource URN-like expression (supporting wildcards) for matching resource(s)
         * @param {string} roleId The ID or fullname of the role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleAllowedGet: (action_1, resource_1, roleId_1, ...args_1) => __awaiter(this, [action_1, resource_1, roleId_1, ...args_1], void 0, function* (action, resource, roleId, options = {}) {
            // verify required parameter 'action' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleAllowedGet', 'action', action);
            // verify required parameter 'resource' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleAllowedGet', 'resource', resource);
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleAllowedGet', 'roleId', roleId);
            const localVarPath = `/v1/role/{role_id}/allowed`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }
            if (resource !== undefined) {
                localVarQueryParameter['resource'] = resource;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the role identified by id
         * @param {string} roleId The ID or fullname associated to the role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleGetById: (roleId_1, human_1, ...args_1) => __awaiter(this, [roleId_1, human_1, ...args_1], void 0, function* (roleId, human, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleGetById', 'roleId', roleId);
            const localVarPath = `/v1/role/{role_id}`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check access to the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleHeadById: (roleId_1, human_1, ...args_1) => __awaiter(this, [roleId_1, human_1, ...args_1], void 0, function* (roleId, human, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleHeadById', 'roleId', roleId);
            const localVarPath = `/v1/role/{role_id}`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'HEAD' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get jobs created by the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleJobGet: (roleId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [roleId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (roleId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleJobGet', 'roleId', roleId);
            const localVarPath = `/v1/role/{role_id}/job`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get runs of jobs created by the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleJobRunGet: (roleId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [roleId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (roleId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleJobRunGet', 'roleId', roleId);
            const localVarPath = `/v1/role/{role_id}/job_run`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a key in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {string} accessKey The ID or fullname of the role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleKeyDelete: (roleId_1, accessKey_1, ...args_1) => __awaiter(this, [roleId_1, accessKey_1, ...args_1], void 0, function* (roleId, accessKey, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleKeyDelete', 'roleId', roleId);
            // verify required parameter 'accessKey' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleKeyDelete', 'accessKey', accessKey);
            const localVarPath = `/v1/role/{role_id}/key/{access_key}`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)))
                .replace(`{${"access_key"}}`, encodeURIComponent(String(accessKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get keys in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleKeyGet: (roleId_1, human_1, ...args_1) => __awaiter(this, [roleId_1, human_1, ...args_1], void 0, function* (roleId, human, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleKeyGet', 'roleId', roleId);
            const localVarPath = `/v1/role/{role_id}/key`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create a key in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RoleKey} [roleKey]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleKeyPost: (roleId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, roleKey_1, ...args_1) => __awaiter(this, [roleId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, roleKey_1, ...args_1], void 0, function* (roleId, limit, offset, order, permission, q, human, roleKey, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleKeyPost', 'roleId', roleId);
            const localVarPath = `/v1/role/{role_id}/key`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(roleKey, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a member in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {string} memberId The ID or fullname of the member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleMemberDelete: (roleId_1, memberId_1, ...args_1) => __awaiter(this, [roleId_1, memberId_1, ...args_1], void 0, function* (roleId, memberId, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleMemberDelete', 'roleId', roleId);
            // verify required parameter 'memberId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleMemberDelete', 'memberId', memberId);
            const localVarPath = `/v1/role/{role_id}/member/{member_id}`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)))
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get members in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {string} [type] Type of the resource to add (team or user)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleMemberGet: (roleId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, type_1, ...args_1) => __awaiter(this, [roleId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, type_1, ...args_1], void 0, function* (roleId, limit, offset, order, permission, q, human, type, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleMemberGet', 'roleId', roleId);
            const localVarPath = `/v1/role/{role_id}/member`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Post a member in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {string} memberId The ID or fullname of the member
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleMemberPost: (roleId_1, memberId_1, human_1, ...args_1) => __awaiter(this, [roleId_1, memberId_1, human_1, ...args_1], void 0, function* (roleId, memberId, human, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleMemberPost', 'roleId', roleId);
            // verify required parameter 'memberId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleMemberPost', 'memberId', memberId);
            const localVarPath = `/v1/role/{role_id}/member/{member_id}`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)))
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a policy in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {string} policyId The ID or fullname of the policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RolePolicyDelete: (roleId_1, policyId_1, ...args_1) => __awaiter(this, [roleId_1, policyId_1, ...args_1], void 0, function* (roleId, policyId, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RolePolicyDelete', 'roleId', roleId);
            // verify required parameter 'policyId' is not null or undefined
            (0, common_1.assertParamExists)('v1RolePolicyDelete', 'policyId', policyId);
            const localVarPath = `/v1/role/{role_id}/policy/{policy_id}`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)))
                .replace(`{${"policy_id"}}`, encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get policies in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [includeInactive] Includes policies that are no longer active
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RolePolicyGet: (roleId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, includeInactive_1, ...args_1) => __awaiter(this, [roleId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, includeInactive_1, ...args_1], void 0, function* (roleId, limit, offset, order, permission, q, human, includeInactive, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RolePolicyGet', 'roleId', roleId);
            const localVarPath = `/v1/role/{role_id}/policy`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (includeInactive !== undefined) {
                localVarQueryParameter['include-inactive'] = includeInactive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Post a policy in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {PolicyPost} [policyPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RolePolicyPost: (roleId_1, human_1, policyPost_1, ...args_1) => __awaiter(this, [roleId_1, human_1, policyPost_1, ...args_1], void 0, function* (roleId, human, policyPost, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RolePolicyPost', 'roleId', roleId);
            const localVarPath = `/v1/role/{role_id}/policy`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(policyPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RolePost} [rolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RolePutById: (roleId_1, human_1, rolePost_1, ...args_1) => __awaiter(this, [roleId_1, human_1, rolePost_1, ...args_1], void 0, function* (roleId, human, rolePost, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RolePutById', 'roleId', roleId);
            const localVarPath = `/v1/role/{role_id}`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rolePost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get roles in the team
         * @param {string} teamId The ID or fullname of the team
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamRoleGet: (teamId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [teamId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (teamId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'teamId' is not null or undefined
            (0, common_1.assertParamExists)('v1TeamRoleGet', 'teamId', teamId);
            const localVarPath = `/v1/team/{team_id}/role`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Post a role in the team
         * @param {string} teamId The ID or fullname of the team
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RolePost} [rolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamRolePost: (teamId_1, human_1, rolePost_1, ...args_1) => __awaiter(this, [teamId_1, human_1, rolePost_1, ...args_1], void 0, function* (teamId, human, rolePost, options = {}) {
            // verify required parameter 'teamId' is not null or undefined
            (0, common_1.assertParamExists)('v1TeamRolePost', 'teamId', teamId);
            const localVarPath = `/v1/team/{team_id}/role`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rolePost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the users and roles that have permission to perform the given action(s) on the given resource(s)
         * @param {string} resource URN-like expression (supporting wildcards) for matching resource(s)
         * @param {string} action Expression (supporting wildcards) denoting the action(s) performed on the resource(s)
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1WhoIsAllowedGet: (resource_1, action_1, limit_1, offset_1, order_1, q_1, human_1, ...args_1) => __awaiter(this, [resource_1, action_1, limit_1, offset_1, order_1, q_1, human_1, ...args_1], void 0, function* (resource, action, limit, offset, order, q, human, options = {}) {
            // verify required parameter 'resource' is not null or undefined
            (0, common_1.assertParamExists)('v1WhoIsAllowedGet', 'resource', resource);
            // verify required parameter 'action' is not null or undefined
            (0, common_1.assertParamExists)('v1WhoIsAllowedGet', 'action', action);
            const localVarPath = `/v1/who_is_allowed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (resource !== undefined) {
                localVarQueryParameter['resource'] = resource;
            }
            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.RoleApiAxiosParamCreator = RoleApiAxiosParamCreator;
/**
 * RoleApi - functional programming interface
 * @export
 */
const RoleApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.RoleApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get policies in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountRoleGet(accountId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountRoleGet(accountId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1AccountRoleGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create role in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RolePost} [rolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountRolePost(accountId, human, rolePost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountRolePost(accountId, human, rolePost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1AccountRolePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get roles in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterRoleGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ClusterRoleGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1ClusterRoleGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get roles in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationRoleGet(organizationId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationRoleGet(organizationId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1OrganizationRoleGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create role in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RolePost} [rolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationRolePost(organizationId, human, rolePost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationRolePost(organizationId, human, rolePost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1OrganizationRolePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get roles in the resource
         * @param {string} resourceId The ID or fullname of the resource
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResourceRoleGet(resourceId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ResourceRoleGet(resourceId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1ResourceRoleGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create role in the resource
         * @param {string} resourceId The ID or fullname of the resource
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RolePost} [rolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResourceRolePost(resourceId, human, rolePost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ResourceRolePost(resourceId, human, rolePost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1ResourceRolePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check permission (action & resource) for a given role
         * @param {string} action Expression (supporting wildcards) denoting the action(s) performed on the resource(s)
         * @param {string} resource URN-like expression (supporting wildcards) for matching resource(s)
         * @param {string} roleId The ID or fullname of the role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleAllowedGet(action, resource, roleId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RoleAllowedGet(action, resource, roleId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1RoleAllowedGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get the role identified by id
         * @param {string} roleId The ID or fullname associated to the role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleGetById(roleId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RoleGetById(roleId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1RoleGetById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check access to the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleHeadById(roleId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RoleHeadById(roleId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1RoleHeadById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get jobs created by the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleJobGet(roleId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RoleJobGet(roleId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1RoleJobGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get runs of jobs created by the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleJobRunGet(roleId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RoleJobRunGet(roleId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1RoleJobRunGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete a key in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {string} accessKey The ID or fullname of the role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleKeyDelete(roleId, accessKey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RoleKeyDelete(roleId, accessKey, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1RoleKeyDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get keys in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleKeyGet(roleId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RoleKeyGet(roleId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1RoleKeyGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create a key in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RoleKey} [roleKey]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleKeyPost(roleId, limit, offset, order, permission, q, human, roleKey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RoleKeyPost(roleId, limit, offset, order, permission, q, human, roleKey, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1RoleKeyPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete a member in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {string} memberId The ID or fullname of the member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleMemberDelete(roleId, memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RoleMemberDelete(roleId, memberId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1RoleMemberDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get members in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {string} [type] Type of the resource to add (team or user)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleMemberGet(roleId, limit, offset, order, permission, q, human, type, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RoleMemberGet(roleId, limit, offset, order, permission, q, human, type, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1RoleMemberGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Post a member in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {string} memberId The ID or fullname of the member
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleMemberPost(roleId, memberId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RoleMemberPost(roleId, memberId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1RoleMemberPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete a policy in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {string} policyId The ID or fullname of the policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RolePolicyDelete(roleId, policyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RolePolicyDelete(roleId, policyId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1RolePolicyDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get policies in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [includeInactive] Includes policies that are no longer active
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RolePolicyGet(roleId, limit, offset, order, permission, q, human, includeInactive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RolePolicyGet(roleId, limit, offset, order, permission, q, human, includeInactive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1RolePolicyGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Post a policy in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {PolicyPost} [policyPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RolePolicyPost(roleId, human, policyPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RolePolicyPost(roleId, human, policyPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1RolePolicyPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RolePost} [rolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RolePutById(roleId, human, rolePost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RolePutById(roleId, human, rolePost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1RolePutById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get roles in the team
         * @param {string} teamId The ID or fullname of the team
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamRoleGet(teamId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1TeamRoleGet(teamId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1TeamRoleGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Post a role in the team
         * @param {string} teamId The ID or fullname of the team
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RolePost} [rolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamRolePost(teamId, human, rolePost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1TeamRolePost(teamId, human, rolePost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1TeamRolePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get the users and roles that have permission to perform the given action(s) on the given resource(s)
         * @param {string} resource URN-like expression (supporting wildcards) for matching resource(s)
         * @param {string} action Expression (supporting wildcards) denoting the action(s) performed on the resource(s)
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1WhoIsAllowedGet(resource, action, limit, offset, order, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1WhoIsAllowedGet(resource, action, limit, offset, order, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.v1WhoIsAllowedGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.RoleApiFp = RoleApiFp;
/**
 * RoleApi - factory interface
 * @export
 */
const RoleApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.RoleApiFp)(configuration);
    return {
        /**
         *
         * @summary Get policies in the account
         * @param {RoleApiV1AccountRoleGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountRoleGet(requestParameters, options) {
            return localVarFp.v1AccountRoleGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create role in the account
         * @param {RoleApiV1AccountRolePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountRolePost(requestParameters, options) {
            return localVarFp.v1AccountRolePost(requestParameters.accountId, requestParameters.human, requestParameters.rolePost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get roles in the cluster
         * @param {RoleApiV1ClusterRoleGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterRoleGet(requestParameters = {}, options) {
            return localVarFp.v1ClusterRoleGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get roles in the organization
         * @param {RoleApiV1OrganizationRoleGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationRoleGet(requestParameters, options) {
            return localVarFp.v1OrganizationRoleGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create role in the organization
         * @param {RoleApiV1OrganizationRolePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationRolePost(requestParameters, options) {
            return localVarFp.v1OrganizationRolePost(requestParameters.organizationId, requestParameters.human, requestParameters.rolePost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get roles in the resource
         * @param {RoleApiV1ResourceRoleGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResourceRoleGet(requestParameters, options) {
            return localVarFp.v1ResourceRoleGet(requestParameters.resourceId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create role in the resource
         * @param {RoleApiV1ResourceRolePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResourceRolePost(requestParameters, options) {
            return localVarFp.v1ResourceRolePost(requestParameters.resourceId, requestParameters.human, requestParameters.rolePost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check permission (action & resource) for a given role
         * @param {RoleApiV1RoleAllowedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleAllowedGet(requestParameters, options) {
            return localVarFp.v1RoleAllowedGet(requestParameters.action, requestParameters.resource, requestParameters.roleId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the role identified by id
         * @param {RoleApiV1RoleGetByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleGetById(requestParameters, options) {
            return localVarFp.v1RoleGetById(requestParameters.roleId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check access to the role
         * @param {RoleApiV1RoleHeadByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleHeadById(requestParameters, options) {
            return localVarFp.v1RoleHeadById(requestParameters.roleId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get jobs created by the role
         * @param {RoleApiV1RoleJobGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleJobGet(requestParameters, options) {
            return localVarFp.v1RoleJobGet(requestParameters.roleId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get runs of jobs created by the role
         * @param {RoleApiV1RoleJobRunGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleJobRunGet(requestParameters, options) {
            return localVarFp.v1RoleJobRunGet(requestParameters.roleId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a key in the role
         * @param {RoleApiV1RoleKeyDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleKeyDelete(requestParameters, options) {
            return localVarFp.v1RoleKeyDelete(requestParameters.roleId, requestParameters.accessKey, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get keys in the role
         * @param {RoleApiV1RoleKeyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleKeyGet(requestParameters, options) {
            return localVarFp.v1RoleKeyGet(requestParameters.roleId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a key in the role
         * @param {RoleApiV1RoleKeyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleKeyPost(requestParameters, options) {
            return localVarFp.v1RoleKeyPost(requestParameters.roleId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.roleKey, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a member in the role
         * @param {RoleApiV1RoleMemberDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleMemberDelete(requestParameters, options) {
            return localVarFp.v1RoleMemberDelete(requestParameters.roleId, requestParameters.memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get members in the role
         * @param {RoleApiV1RoleMemberGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleMemberGet(requestParameters, options) {
            return localVarFp.v1RoleMemberGet(requestParameters.roleId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post a member in the role
         * @param {RoleApiV1RoleMemberPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleMemberPost(requestParameters, options) {
            return localVarFp.v1RoleMemberPost(requestParameters.roleId, requestParameters.memberId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a policy in the role
         * @param {RoleApiV1RolePolicyDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RolePolicyDelete(requestParameters, options) {
            return localVarFp.v1RolePolicyDelete(requestParameters.roleId, requestParameters.policyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get policies in the role
         * @param {RoleApiV1RolePolicyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RolePolicyGet(requestParameters, options) {
            return localVarFp.v1RolePolicyGet(requestParameters.roleId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.includeInactive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post a policy in the role
         * @param {RoleApiV1RolePolicyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RolePolicyPost(requestParameters, options) {
            return localVarFp.v1RolePolicyPost(requestParameters.roleId, requestParameters.human, requestParameters.policyPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update role
         * @param {RoleApiV1RolePutByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RolePutById(requestParameters, options) {
            return localVarFp.v1RolePutById(requestParameters.roleId, requestParameters.human, requestParameters.rolePost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get roles in the team
         * @param {RoleApiV1TeamRoleGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamRoleGet(requestParameters, options) {
            return localVarFp.v1TeamRoleGet(requestParameters.teamId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post a role in the team
         * @param {RoleApiV1TeamRolePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamRolePost(requestParameters, options) {
            return localVarFp.v1TeamRolePost(requestParameters.teamId, requestParameters.human, requestParameters.rolePost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the users and roles that have permission to perform the given action(s) on the given resource(s)
         * @param {RoleApiV1WhoIsAllowedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1WhoIsAllowedGet(requestParameters, options) {
            return localVarFp.v1WhoIsAllowedGet(requestParameters.resource, requestParameters.action, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
    };
};
exports.RoleApiFactory = RoleApiFactory;
/**
 * RoleApi - object-oriented interface
 * @export
 * @class RoleApi
 * @extends {BaseAPI}
 */
class RoleApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get policies in the account
     * @param {RoleApiV1AccountRoleGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1AccountRoleGet(requestParameters, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1AccountRoleGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create role in the account
     * @param {RoleApiV1AccountRolePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1AccountRolePost(requestParameters, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1AccountRolePost(requestParameters.accountId, requestParameters.human, requestParameters.rolePost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get roles in the cluster
     * @param {RoleApiV1ClusterRoleGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1ClusterRoleGet(requestParameters = {}, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1ClusterRoleGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get roles in the organization
     * @param {RoleApiV1OrganizationRoleGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1OrganizationRoleGet(requestParameters, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1OrganizationRoleGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create role in the organization
     * @param {RoleApiV1OrganizationRolePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1OrganizationRolePost(requestParameters, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1OrganizationRolePost(requestParameters.organizationId, requestParameters.human, requestParameters.rolePost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get roles in the resource
     * @param {RoleApiV1ResourceRoleGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1ResourceRoleGet(requestParameters, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1ResourceRoleGet(requestParameters.resourceId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create role in the resource
     * @param {RoleApiV1ResourceRolePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1ResourceRolePost(requestParameters, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1ResourceRolePost(requestParameters.resourceId, requestParameters.human, requestParameters.rolePost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check permission (action & resource) for a given role
     * @param {RoleApiV1RoleAllowedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1RoleAllowedGet(requestParameters, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1RoleAllowedGet(requestParameters.action, requestParameters.resource, requestParameters.roleId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the role identified by id
     * @param {RoleApiV1RoleGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1RoleGetById(requestParameters, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1RoleGetById(requestParameters.roleId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check access to the role
     * @param {RoleApiV1RoleHeadByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1RoleHeadById(requestParameters, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1RoleHeadById(requestParameters.roleId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get jobs created by the role
     * @param {RoleApiV1RoleJobGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1RoleJobGet(requestParameters, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1RoleJobGet(requestParameters.roleId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get runs of jobs created by the role
     * @param {RoleApiV1RoleJobRunGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1RoleJobRunGet(requestParameters, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1RoleJobRunGet(requestParameters.roleId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a key in the role
     * @param {RoleApiV1RoleKeyDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1RoleKeyDelete(requestParameters, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1RoleKeyDelete(requestParameters.roleId, requestParameters.accessKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get keys in the role
     * @param {RoleApiV1RoleKeyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1RoleKeyGet(requestParameters, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1RoleKeyGet(requestParameters.roleId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a key in the role
     * @param {RoleApiV1RoleKeyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1RoleKeyPost(requestParameters, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1RoleKeyPost(requestParameters.roleId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.roleKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a member in the role
     * @param {RoleApiV1RoleMemberDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1RoleMemberDelete(requestParameters, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1RoleMemberDelete(requestParameters.roleId, requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get members in the role
     * @param {RoleApiV1RoleMemberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1RoleMemberGet(requestParameters, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1RoleMemberGet(requestParameters.roleId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post a member in the role
     * @param {RoleApiV1RoleMemberPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1RoleMemberPost(requestParameters, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1RoleMemberPost(requestParameters.roleId, requestParameters.memberId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a policy in the role
     * @param {RoleApiV1RolePolicyDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1RolePolicyDelete(requestParameters, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1RolePolicyDelete(requestParameters.roleId, requestParameters.policyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get policies in the role
     * @param {RoleApiV1RolePolicyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1RolePolicyGet(requestParameters, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1RolePolicyGet(requestParameters.roleId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.includeInactive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post a policy in the role
     * @param {RoleApiV1RolePolicyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1RolePolicyPost(requestParameters, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1RolePolicyPost(requestParameters.roleId, requestParameters.human, requestParameters.policyPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update role
     * @param {RoleApiV1RolePutByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1RolePutById(requestParameters, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1RolePutById(requestParameters.roleId, requestParameters.human, requestParameters.rolePost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get roles in the team
     * @param {RoleApiV1TeamRoleGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1TeamRoleGet(requestParameters, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1TeamRoleGet(requestParameters.teamId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post a role in the team
     * @param {RoleApiV1TeamRolePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1TeamRolePost(requestParameters, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1TeamRolePost(requestParameters.teamId, requestParameters.human, requestParameters.rolePost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the users and roles that have permission to perform the given action(s) on the given resource(s)
     * @param {RoleApiV1WhoIsAllowedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    v1WhoIsAllowedGet(requestParameters, options) {
        return (0, exports.RoleApiFp)(this.configuration).v1WhoIsAllowedGet(requestParameters.resource, requestParameters.action, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.RoleApi = RoleApi;
